export function starlingLog(...msg: any[]): void {
  return console.info('[Staring Info]', ...msg);
}
